var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.displayPage == "billing"
        ? _c(
            "div",
            { staticClass: "col-sm-12 col-xs-12 col-md-12 box-wrapper" },
            [
              _vm._l(_vm.addedPlans, function (plan) {
                return _c("div", { key: plan.id }, [
                  plan.id === 1 ||
                  plan.id === 2 ||
                  plan.id === 4 ||
                  plan.id === 3 ||
                  plan.id === 15 ||
                  plan.id === 13 ||
                  plan.id === 14 ||
                  plan.id === 16 ||
                  (plan.id === 7 && plan.service_type == "premium") ||
                  plan.id !== 7
                    ? _c("div", [
                        (plan.id === 7 && plan.service_type == "premium") ||
                        plan.id !== 7
                          ? _c("div", { staticClass: "row service-charges" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-4 col-md-4 col-sm-6 col-xs-10",
                                },
                                [
                                  _c("p", { staticClass: "white-space" }, [
                                    _vm._v(_vm._s(plan.name)),
                                  ]),
                                ]
                              ),
                              _c("div", {
                                staticClass:
                                  "col-lg-4 col-md-4 col-sm-2 col-xs-4 dollar-per-month",
                              }),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-4",
                                },
                                [
                                  plan.id === 2
                                    ? _c("p", [
                                        _vm._v(
                                          "$" +
                                            _vm._s(_vm.regIntelPrice) +
                                            "/year"
                                        ),
                                      ])
                                    : _c("p", [
                                        (plan.id === 7 &&
                                          plan.service_type == "premium") ||
                                        plan.id !== 7
                                          ? _c("span", [
                                              _vm._v(
                                                "$" +
                                                  _vm._s(plan.price) +
                                                  "/year"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _c("hr", { staticClass: "upper-line" }),
                        (plan.id === 7 && plan.service_type == "premium") ||
                        plan.id !== 7
                          ? _c("div", { staticClass: "current-total" }, [
                              _c("div", { staticClass: "row" }, [
                                _vm._m(0, true),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-4 col-md-4 col-sm-4 col-xs-5",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFormat")(
                                            plan.last_modified
                                          )
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("div", {
                                  staticClass:
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-2",
                                }),
                              ]),
                              _c("div", { staticClass: "row" }, [
                                _vm._m(1, true),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "col-lg-4 col-md-4 col-sm-4 col-xs-5",
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("dateFormat")(plan.valid_until)
                                        )
                                      ),
                                    ]),
                                  ]
                                ),
                                _c("div", {
                                  staticClass:
                                    "col-lg-4 col-md-4 col-sm-4 col-xs-2",
                                }),
                              ]),
                              _c("hr", { staticClass: "billing-hr-line" }),
                            ])
                          : _vm._e(),
                      ])
                    : _vm._e(),
                ])
              }),
              _c("div", [
                _vm.displayNoService
                  ? _c("div", { staticClass: "row service-charges" }, [
                      _c("div", { staticClass: "row m-0" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-lg-12 col-md-12 col-sm-12 col-xs-12 team-member-reg pl-25",
                          },
                          [
                            _c("notification-no-service", {
                              on: {
                                closepopup: function ($event) {
                                  return _vm.$emit("closepopup")
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ])
                  : _vm._e(),
              ]),
              _vm.addedPlans && _vm.addedPlans.length > 0
                ? _c("div", { staticClass: "save-payment-method" }, [
                    _vm.billingDetails && _vm.billingDetails.email_address
                      ? _c("div", { staticClass: "row" }, [
                          _vm._m(2),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-4 col-md-4 col-sm-4 col-xs-10",
                            },
                            [
                              _c("p", { staticClass: "billing-address" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.billingDetails.first_name) +
                                    " " +
                                    _vm._s(_vm.billingDetails.last_name) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.billingDetails.email_address) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.billingDetails.phone_number) +
                                    " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " + _vm._s(_vm.billingDetails.address) + " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " + _vm._s(_vm.billingDetails.city) + " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " + _vm._s(_vm.billingDetails.state) + " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " + _vm._s(_vm.billingDetails.country) + " "
                                ),
                                _c("br"),
                                _vm._v(
                                  " " + _vm._s(_vm.billingDetails.zipcode) + " "
                                ),
                              ]),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ])
                : _vm._e(),
              _vm.billingDetails && _vm.billingDetails.email_address
                ? _c("div", { staticClass: "row" }, [_vm._m(3)])
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _vm.displayPage !== "billing"
        ? _c("div", { staticClass: "col-sm-12 col-xs-12" }, [_c("hr")])
        : _vm._e(),
      _vm.displayPage == "payment"
        ? _c(
            "div",
            { staticClass: "col-lg-12 col-md-12 col-sm-12 billingInfo" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "credit-payment-borderTable saved-payment-method",
                },
                [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.payment_method,
                            expression: "payment_method",
                          },
                        ],
                        attrs: {
                          type: "radio",
                          id: "save-card",
                          name: "payment-radio-group-mn",
                          value: "saved_card",
                        },
                        domProps: {
                          checked: _vm._q(_vm.payment_method, "saved_card"),
                        },
                        on: {
                          change: function ($event) {
                            _vm.payment_method = "saved_card"
                          },
                        },
                      }),
                      _c(
                        "label",
                        {
                          staticClass: "default-card",
                          attrs: { for: "save-card" },
                        },
                        [_vm._v("Saved Payment Method")]
                      ),
                    ]),
                    _vm._m(4),
                  ]),
                  _vm.payment_method == "saved_card"
                    ? _c("div", [
                        _c("div", { staticClass: "row content" }, [
                          _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "header-label",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(" Full Name (as it appears on card) "),
                                  !_vm.user_data.full_name
                                    ? _c(
                                        "span",
                                        { staticClass: "required_astric" },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.user_data.full_name.$model,
                                    expression: "$v.user_data.full_name.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                class: _vm.$v.user_data.full_name.$error
                                  ? "invalid-border"
                                  : "",
                                attrs: {
                                  type: "text",
                                  placeholder: "Full Name",
                                },
                                domProps: {
                                  value: _vm.$v.user_data.full_name.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.user_data.full_name,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.$v.user_data.full_name.$error
                                ? _c("div", [
                                    !_vm.$v.user_data.full_name.required
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Complete required field ")]
                                        )
                                      : !_vm.$v.user_data.full_name.isFullName
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [
                                            _vm._v(
                                              " Please enter a valid name. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "header-label",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(" Credit Card Number "),
                                  !_vm.user_data.credit_card_num
                                    ? _c(
                                        "span",
                                        { staticClass: "required_astric" },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value:
                                      _vm.$v.user_data.credit_card_num.$model,
                                    expression:
                                      "$v.user_data.credit_card_num.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                class: _vm.$v.user_data.credit_card_num.$error
                                  ? "invalid-border"
                                  : "",
                                attrs: {
                                  type: "text",
                                  placeholder: "Card Number",
                                  maxlength: "17",
                                },
                                domProps: {
                                  value:
                                    _vm.$v.user_data.credit_card_num.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.user_data.credit_card_num,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.$v.user_data.credit_card_num.$error
                                ? _c("div", [
                                    !_vm.$v.user_data.credit_card_num.required
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Complete required field ")]
                                        )
                                      : !_vm.$v.user_data.credit_card_num
                                          .isNumberCredit
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Please valid numbers ")]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _c("div", { staticClass: "row content" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-lg-6 col-md-6 col-sm-6 header-label",
                            },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "header-label",
                                  attrs: { for: "" },
                                },
                                [_vm._v("Expiration Date")]
                              ),
                              !_vm.user_data.exp_date
                                ? _c(
                                    "span",
                                    { staticClass: "required_astric" },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c("div", { staticClass: "row content" }, [
                          _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                            _c("div", { staticClass: "row" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-6 col-md-6 col-sm-6 col-xs-6",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "header-label",
                                          attrs: { for: "" },
                                        },
                                        [_vm._v("Month")]
                                      ),
                                      _c("multiselect", {
                                        staticClass:
                                          "multiselect-single-dropdown",
                                        class: !_vm.mnthvalue
                                          ? "un-selected"
                                          : "",
                                        attrs: {
                                          options: _vm.arrMonth,
                                          placeholder: "MM",
                                          "show-labels": false,
                                          "allow-empty": false,
                                          searchable: false,
                                        },
                                        model: {
                                          value: _vm.mnthvalue,
                                          callback: function ($$v) {
                                            _vm.mnthvalue = $$v
                                          },
                                          expression: "mnthvalue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-lg-6 col-md-6 col-sm-6 col-xs-6",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-group" },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass: "header-label",
                                          attrs: { for: "" },
                                        },
                                        [_vm._v("Year")]
                                      ),
                                      _c("multiselect", {
                                        staticClass:
                                          "multiselect-single-dropdown",
                                        class: !_vm.yearValue
                                          ? "un-selected"
                                          : "",
                                        attrs: {
                                          options: _vm.arrYear,
                                          placeholder: "YY",
                                          "show-labels": false,
                                          "allow-empty": false,
                                          searchable: false,
                                        },
                                        model: {
                                          value: _vm.yearValue,
                                          callback: function ($$v) {
                                            _vm.yearValue = $$v
                                          },
                                          expression: "yearValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "header-label",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(" Security code (CVV) "),
                                  !_vm.user_data.security_code
                                    ? _c(
                                        "span",
                                        { staticClass: "required_astric" },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value:
                                      _vm.$v.user_data.security_code.$model,
                                    expression:
                                      "$v.user_data.security_code.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                class: _vm.$v.user_data.security_code.$error
                                  ? "invalid-border"
                                  : "",
                                attrs: {
                                  type: "text",
                                  placeholder: "XXX",
                                  maxlength: "4",
                                },
                                domProps: {
                                  value: _vm.$v.user_data.security_code.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.user_data.security_code,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.$v.user_data.security_code.$error
                                ? _c("div", [
                                    !_vm.$v.user_data.security_code.required
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Complete required field ")]
                                        )
                                      : !_vm.$v.user_data.security_code
                                          .isCreditCard
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Please enter valid CVV ")]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                        _c("hr"),
                        _c("div", { staticClass: "row content" }, [
                          _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "header-label",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(" First Name "),
                                  !_vm.user_data.first_name
                                    ? _c(
                                        "span",
                                        { staticClass: "required_astric" },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.user_data.first_name.$model,
                                    expression:
                                      "$v.user_data.first_name.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                class: _vm.$v.user_data.first_name.$error
                                  ? "invalid-border"
                                  : "",
                                attrs: {
                                  type: "text",
                                  placeholder: "First Name",
                                  maxlength: "65",
                                },
                                domProps: {
                                  value: _vm.$v.user_data.first_name.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.user_data.first_name,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.$v.user_data.first_name.$error
                                ? _c("div", [
                                    !_vm.$v.user_data.first_name.required
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Complete required field ")]
                                        )
                                      : !_vm.$v.user_data.first_name.minLength
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [
                                            _vm._v(
                                              " Minimum 2 characters required. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c("div", { staticClass: "col-md-6 col-sm-6" }, [
                            _c("div", { staticClass: "form-group" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "header-label",
                                  attrs: { for: "" },
                                },
                                [
                                  _vm._v(" Last Name "),
                                  !_vm.user_data.last_name
                                    ? _c(
                                        "span",
                                        { staticClass: "required_astric" },
                                        [_vm._v("*")]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model.trim",
                                    value: _vm.$v.user_data.last_name.$model,
                                    expression: "$v.user_data.last_name.$model",
                                    modifiers: { trim: true },
                                  },
                                ],
                                staticClass: "form-control",
                                class: _vm.$v.user_data.last_name.$error
                                  ? "invalid-border"
                                  : "",
                                attrs: {
                                  type: "text",
                                  placeholder: "Last Name",
                                  maxlength: "65",
                                },
                                domProps: {
                                  value: _vm.$v.user_data.last_name.$model,
                                },
                                on: {
                                  input: function ($event) {
                                    if ($event.target.composing) return
                                    _vm.$set(
                                      _vm.$v.user_data.last_name,
                                      "$model",
                                      $event.target.value.trim()
                                    )
                                  },
                                  blur: function ($event) {
                                    return _vm.$forceUpdate()
                                  },
                                },
                              }),
                              _vm.$v.user_data.last_name.$error
                                ? _c("div", [
                                    !_vm.$v.user_data.last_name.required
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [_vm._v(" Complete required field ")]
                                        )
                                      : !_vm.$v.user_data.last_name.minLength
                                      ? _c(
                                          "div",
                                          { staticClass: "custom-error-class" },
                                          [
                                            _vm._v(
                                              " Minimum 2 characters required. "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
              _c("div", { staticClass: "credit-payment-borderTable" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payment_method,
                          expression: "payment_method",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "newCredit-card",
                        name: "payment-radio-group-mn",
                        value: "new_card",
                      },
                      domProps: {
                        checked: _vm._q(_vm.payment_method, "new_card"),
                      },
                      on: {
                        change: function ($event) {
                          _vm.payment_method = "new_card"
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "default-card",
                        attrs: { for: "newCredit-card" },
                      },
                      [_vm._v("Add New Credit card")]
                    ),
                  ]),
                  _vm._m(5),
                ]),
              ]),
              _c("div", { staticClass: "credit-payment-borderTable" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payment_method,
                          expression: "payment_method",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "invoice-card",
                        name: "payment-radio-group-mn",
                        value: "invoice",
                      },
                      domProps: {
                        checked: _vm._q(_vm.payment_method, "invoice"),
                      },
                      on: {
                        change: function ($event) {
                          _vm.payment_method = "invoice"
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "default-card",
                        attrs: { for: "invoice-card" },
                      },
                      [_vm._v("Add Invoice")]
                    ),
                  ]),
                  _vm._m(6),
                ]),
              ]),
              _c("div", { staticClass: "credit-payment-borderTable" }, [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.payment_method,
                          expression: "payment_method",
                        },
                      ],
                      attrs: {
                        type: "radio",
                        id: "purchase-card",
                        name: "payment-radio-group-mn",
                        value: "purchase_order",
                      },
                      domProps: {
                        checked: _vm._q(_vm.payment_method, "purchase_order"),
                      },
                      on: {
                        change: function ($event) {
                          _vm.payment_method = "purchase_order"
                        },
                      },
                    }),
                    _c(
                      "label",
                      {
                        staticClass: "default-card",
                        attrs: { for: "purchase-card" },
                      },
                      [_vm._v("Add Purchase Order")]
                    ),
                  ]),
                  _vm._m(7),
                ]),
              ]),
            ]
          )
        : _vm._e(),
      _vm.displayPage == "billinginfo"
        ? _c("billing-info", {
            ref: "billingInfo",
            attrs: { purchaseOrder: _vm.payment_method == "purchase_order" },
          })
        : _vm._e(),
      _vm.displayPage == "billinginfo" || _vm.displayPage == "payment"
        ? _c(
            "div",
            { staticClass: "col-sm-12 col-xs-12 col-lg-12 col-md-12 mt-10" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-2 col-md-offset-7 col-sm-offset-5 col-sm-3 col-xs-5 pr-0 xs-pd-lt-0",
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block emergo-white-button",
                      attrs: { type: "button" },
                      on: { click: _vm.navigateToMain },
                    },
                    [_vm._v(" Cancel ")]
                  ),
                ]
              ),
              _c(
                "div",
                {
                  staticClass:
                    "col-lg-3 col-md-3 col-sm-4 col-xs-7 pr-0 xs-pd-lt-0 xs-pd-rt-0",
                },
                [
                  _vm.displayPage == "payment"
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.displayPage == "payment"
                                ? _vm.submitBillingInfo
                                : null
                            },
                          },
                        },
                        [_vm._v(" Save Changes ")]
                      )
                    : _vm._e(),
                ]
              ),
            ]
          )
        : _vm._e(),
      _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-5" }, [
      _c("p", { staticClass: "item-name" }, [_vm._v("Last Bill due")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-5" }, [
      _c("p", { staticClass: "item-name" }, [_vm._v("Next Bill due")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-4 col-md-4 col-sm-4 col-xs-10 billing-header" },
      [_c("p", [_vm._v("Billing information")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 rams-billing" },
      [
        _c("p", { staticClass: "rams-billing-para" }, [
          _vm._v(
            " If you would like a copy of your invoices or having any billing questions email "
          ),
          _c("a", { attrs: { href: "mailto:ramshelp@ul.com" } }, [
            _vm._v("RAMSHelp@ul.com"),
          ]),
        ]),
      ]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
      _c("input", {
        staticClass: "styled-checkbox",
        attrs: { type: "checkbox", id: "save-payment-method" },
      }),
      _c(
        "label",
        {
          staticClass: "label-payment-method",
          attrs: { for: "save-payment-method" },
        },
        [_vm._v("Make default payment method")]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
      _c("input", {
        staticClass: "styled-checkbox",
        attrs: { type: "checkbox", id: "newCredit-payment-method" },
      }),
      _c("label", { attrs: { for: "newCredit-payment-method" } }, [
        _vm._v("Make default payment method"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
      _c("input", {
        staticClass: "styled-checkbox",
        attrs: { type: "checkbox", id: "invoice-payment-method" },
      }),
      _c("label", { attrs: { for: "invoice-payment-method" } }, [
        _vm._v("Make default payment method"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-lg-6 col-md-6 col-sm-6" }, [
      _c("input", {
        staticClass: "styled-checkbox",
        attrs: { type: "checkbox", id: "purchase-payment-method" },
      }),
      _c("label", { attrs: { for: "purchase-payment-method" } }, [
        _vm._v("Make default payment method"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }